import React from 'react';
import { Box } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export type ContentStatus = 'draft' | 'private' | 'public' | 'archived';

const STYLE: Record<ContentStatus, { fg: string; bg: string; bd: string; label: string }> = {
  draft:    { fg: '#475569', bg: '#F1F5F9', bd: '#E2E8F0', label: 'Draft' },
  private:  { fg: '#075985', bg: '#E0F2FE', bd: '#BAE6FD', label: 'Private' },
  public:   { fg: '#065F46', bg: '#D1FAE5', bd: '#A7F3D0', label: 'Public' },
  archived: { fg: '#92400E', bg: '#FEF3C7', bd: '#FDE68A', label: 'Archived' },
};

export interface StatusPillProps {
  status: ContentStatus;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, onClick }) => {
  const s = STYLE[status];
  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={(e) => { e.stopPropagation(); onClick(e); }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(e as unknown as React.MouseEvent<HTMLDivElement>);
        }
      }}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.5,
        borderRadius: 999,
        border: `1.5px solid ${s.bd}`,
        background: s.bg,
        color: s.fg,
        fontWeight: 700,
        fontSize: 12,
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': { filter: 'brightness(0.96)' },
      }}
    >
      <Box sx={{ width: 7, height: 7, borderRadius: '50%', background: 'currentColor' }} />
      {s.label}
      <ArrowDropDownIcon sx={{ fontSize: 16, opacity: 0.6, ml: -0.5 }} />
    </Box>
  );
};
